<template>
  <div>
    <div>
      <div class="form-group">
        <label
          ><h5 style="width: 200px">
            <i class="bi bi-gift"></i> 달란트 현황
          </h5></label
        >
      </div>
    </div>

    <!-- 날짜 선택 -->
    <div class="card mb-3">
      <div class="card-body" style="padding: 0.5rem;">
        <div class="d-flex align-items-center justify-content-center">
          <input type="date" class="form-control form-control-sm mr-1" id="fromDate" v-model="fromDate" style="max-width: 130px;">
          <span class="mx-1">~</span>
          <input type="date" class="form-control form-control-sm ml-1 mr-2" id="toDate" v-model="toDate" style="max-width: 130px;">
          <button type="button" class="btn btn-primary btn-sm" @click="searchData" style="white-space: nowrap;">조회</button>
        </div>
      </div>
    </div>

    <!-- 반 선택 -->
    <div v-show="role < 3">
      <select
        class="form-control"
        id="gradegroup"
        v-model="gradegroup"
        @change="searchData"
      >
        <option value="00">전체 반</option>
        <option
          v-for="gradelist in gradegrouplist"
          :key="String(gradelist.teacherid) + '-' + String(gradelist.grade != null ? gradelist.grade : '')"
          :value="gradelist.grade"
        >
          {{ gradeListLabel(gradelist) }}
        </option>
      </select>
    </div>
    <p></p>

    <!-- 달란트 리스트 -->
    <div class="card">
      <h5 class="card-header">달란트 합계 현황</h5>
      <div class="card-body">
        <div v-if="talentList.length > 0">
          <table class="table table-bordered table-striped">
            <thead>
              <tr style="text-align: center;">
                <th scope="col">이름</th>
                <th scope="col">학년/반</th>
                <th scope="col">총 달란트</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item, index) in talentList" :key="index" style="text-align: center;">
                <td>{{ item.name }}</td>
                <td>{{ getGradeName(item.grade) }}</td>
                <td style="color: blue; font-weight: bold;">{{ item.total_points }}</td>
              </tr>
            </tbody>
          </table>
        </div>
        <div v-else class="text-center">
          자료가 없습니다.
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import manageService from "../services/manageService";
import dayjs from 'dayjs';

export default {
  name: "TalentTotal",
  data() {
    return {
      fromDate: dayjs().startOf('year').format('YYYY-MM-DD'),
      toDate: dayjs().format('YYYY-MM-DD'),
      gradegroup: "00",
      gradegrouplist: [],
      talentList: [],
      
      id: this.$store.state.id,
      role: this.$store.state.role,
      classid: this.$store.state.classid,
    };
  },
  created() {
    // classid 1,2,3,4 접근 제한
    if (['1', '2', '3', '4'].includes(this.classid)) {
      this.$toast.warning("해당 부서는 접근할 수 없습니다.");
      this.$router.push('/dashboard');
      return;
    }
    this.getGradeGroupList();
    // 초기 로딩 시 조회
    this.searchData();
  },
  methods: {
    gradeListLabel(g) {
      if (!g) return "";
      if (g.listlabel != null && g.listlabel !== "") return g.listlabel;
      const a = (g.gradename != null ? String(g.gradename) : "").trim();
      const b = (g.teachername != null ? String(g.teachername) : "").trim();
      const hideNames = ["선생님", "새가족", "새친구", "새얼굴"];
      if (hideNames.includes(a)) return a;
      if (a && b) return `${a} ${b}`;
      return a || b;
    },
    getGradeGroupList() {
      const data = {
        classid: this.classid,
      };

      manageService
        .getGradeListAll(data)
        .then((response) => {
          this.gradegrouplist = response.data;
        })
        .catch((e) => {
          console.log(e);
        });
    },
    searchData() {
      if (['1', '2', '3', '4'].includes(this.classid)) return;

      const data = {
        classid: this.classid,
        grade: this.gradegroup,
        from_date: this.fromDate,
        to_date: this.toDate
      };

      manageService
        .getTalentTotal(data)
        .then((response) => {
          this.talentList = response.data;
        })
        .catch((e) => {
          console.log(e);
          this.talentList = [];
        });
    },
    getGradeName(gradeCode) {
      if (!this.gradegrouplist || this.gradegrouplist.length === 0) return gradeCode;
      const found = this.gradegrouplist.find((g) => g.grade === gradeCode);
      if (!found) return gradeCode;
      return this.gradeListLabel(found);
    }
  }
};
</script>

<style scoped>
.card-header {
  background-color: rgb(0 123 255 / 22%);
}
</style>

